var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our-people"},[_c('b-container',_vm._l((_vm.persons),function(person,index){return _c('b-row',{key:index},[_c('b-col',{staticClass:"person-data"},[_c('Peopleinfo',{attrs:{"person":person}})],1)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }